module.exports = __webpack_public_path__ + "static/RootSans-14UltraItalic-177e9316ac41962fe3c01ca04c35fbf1.woff2";